import { render } from "./RegistroAutos.vue?vue&type=template&id=3b90a0a2&scoped=true"
import script from "./RegistroAutos.vue?vue&type=script&lang=js"
export * from "./RegistroAutos.vue?vue&type=script&lang=js"

import "./RegistroAutos.vue?vue&type=style&index=0&id=3b90a0a2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b90a0a2"]])

export default __exports__